import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Get, Put, Post } from 'utils/axios-token'
import { requestSuccess, requestError } from 'utils/requestHandler'
import { convertSearchObjectToBase64 } from 'utils/objToBase64'

import Lang from 'Lang/General'

const HOC = ( WrappedComponent ) => {
  class WithHOC extends Component {
    state = {
      brandListing: [],
      loading: false,
      selectedBrand: null
    }

    onChangeBrandHOC = ( key, value ) => this.setState({ [key]: value })

    load = val => this.setState({loading: val})

    getBrandsListing = portalUserID => Get(
      `/api/v1/fex/brands?query=${convertSearchObjectToBase64({"is_paginated":false,"filter":{"user_id":portalUserID}})}`,
      payload => this.setState({ brandListing: payload.data }),
      error => requestError(error),
      this.load
    )

    updateBrand = dataToSubmit => Put(
      `/api/v1/fex/brands/${dataToSubmit.id}`,
      dataToSubmit,
      () => {
        this.props.onChangePortalUsersHOC('showUploadModal', false )
        this.getBrandsListing(dataToSubmit.user_id)
        requestSuccess(Lang[ 'RECORD_UPDATED_SUCCESSFULLY' ][ this.props.data.languageReducer.userSettings.admin_panel_language ])
      },
      error => requestError(error),
      this.load
    )
    createBrand = dataToSubmit => Post(
      `/api/v1/fex/brands`,
      dataToSubmit,
      () => {
        this.props.onChangePortalUsersHOC('showUploadModal', false )
        this.getBrandsListing(dataToSubmit.user_id)
        requestSuccess(Lang[ 'RECORD_CREATE_SUCCESS' ][ this.props.data.languageReducer.userSettings.admin_panel_language ])
      },
      error => requestError(error),
      this.load
    )

    render = () => {
      return(
        <>
          <WrappedComponent
            { ...this.props }
            { ... this.state }
            onLoadBrand={this.state.loading}

            onChangeBrandHOC={ this.onChangeBrandHOC }
            getBrandsListing={this.getBrandsListing}
            updateBrand={this.updateBrand} 
            createBrand={this.createBrand}
          />
        </>
      )
    }

  }
  const mapStateToProps = state => ({ data: state })
  return connect( mapStateToProps)( WithHOC )
}

export default HOC
